import { Box, Grid } from "@mui/material";
import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EmptyComponent from "../../../utils/EmptyComponent";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BaseURL from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import useFetch from "../../../utils/useFetch";

import axios from "../../../utils/fvAxios";
import TemplateItem from "./TemplateItem";
import CollectionsTemplate from "../../../components/CollectionsTemplate";
import TemplateCollectionControls from "./TemplateCollectionControls";

const pageSize = 12;

function templatesDataAdaptor(data) {
  return {
    headers: [
      { id: "TemplateName", text: "Name", width: "70%" },
      { id: "icon", width: "2%" },
      { id: "icons", width: "5%" },
    ],
    isEditable: {
      callback: (item) => {},
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => {},
      isVisible: true,
    },
    rows: data?.data?.map((d,i) =>
    Object.assign({}, d, {
      key: d.templateId,
    })
  ),
  };
}

function toQueryString(obj) {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
}

function getUrl(url, data) {
  return `${url}${toQueryString(data)}`;
}

export default function CustomExistingTemplates() {
  const queryUrl = BaseURL.baseUrl + BaseURL.templateTool.GetTemplates;
  const [viewType, setViewType] = useState("list");
  const [filterObj, setFilterObj] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [collection, setCollection] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [paramsState, setParamsState] = useState({
    searchStr: "",
    isDownloadRequest: false,
    pageSize: pageSize,
    pageNumber: 1,
  });

  const [url, setUrl] = useState(
    getUrl(queryUrl, { ...paramsState, pageSize })
  );

  const { data: collectionData, loading, error } = useFetch(url);

  useLayoutEffect(() => {
    if(isNaN(paramsState.pageNumber) || +paramsState.pageNumber < 1){
      setParamsState({...paramsState,pageNumber :1})
    }
    else{
      setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
    } 
  }, [paramsState]);

  const [accordiansExpanded, setAccordionsExpanded] = useState([]);
  const handleAccordion = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setAccordionsExpanded([panel]);
    } else {
      setAccordionsExpanded([]);
    }
  };
  useLayoutEffect(() => {
    if (collectionData) {
      setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setCollection(
        templatesDataAdaptor
          ? templatesDataAdaptor(collectionData)
          : collectionData
      );
    }
  }, [collectionData]);

  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setPage(pageNumber) {   
    setPageNumber(pageNumber);
    setParamsState((prev) => ({ ...prev, pageNumber }));
  }
  function setSearchStr(str) {
    setParamsState({
      ...paramsState,
      searchStr: str,
      pageNumber: 1,
    });
  }
  return (
    <Box sx={{ padding: "10px" }}>
      <div
        px={2}
        className="list pe-5"
      >
        <CollectionsTemplate
          TitlebarChildren={EmptyComponent}
          page={paramsState.pageNumber}
          setPage={setPage}
          pageCount={pageCount}
          fetchState={{ loading, error }}
          collection={collection}
          viewType={viewType}
          responseDataAdaptor={templatesDataAdaptor}
          ListItemComponent={TemplateItem}
          GridItemComponent={EmptyComponent}
          SlidingPopupTitle="User Filters"
          SlidingPopupContent={<EmptyComponent />}
          CollectionControls={(props) => (
            <TemplateCollectionControls
              setSearchStr={setSearchStr}
              searchStr={paramsState.searchStr}
              toggleViewType={toggleViewType}
              viewType={viewType}
              searchPlaceholder="Search Template"
              downloadUrl={url}
              fileName={"Templates"}
              {...props}
            />
          )}
          filterObj={filterObj}
        />
      </div>
    </Box>
  );
}
